import { Button } from "@mui/material";
import { NavLink } from "react-router-dom";

export default function JoinUs({prof,text}){
    console.log(prof)
    console.log(prof)
    return (
      <NavLink
        to={prof===true?"/signupasprof":"/signupwithphone"}
        style={{ textAlign: "center", display: "block", textDecoration: "none" }}
      >
        <Button
          variant="contained"
          sx={{
            minHeight: 48,
            px: { xs: 3.5, md: 5 },
            py: 1.2,
            borderRadius: "14px",
            fontSize: { xs: "1rem", md: "1.1rem" },
            fontFamily: "Assistant",
            fontWeight: 800,
            textTransform: "none",
            color: "#fff",
            background: "linear-gradient(135deg, #168de2 0%, #0874c8 100%)",
            boxShadow: "0 10px 22px rgba(12, 116, 200, .24)",
            transition: "transform .2s ease, box-shadow .2s ease",
            "&:hover": {
              background: "linear-gradient(135deg, #147fc9 0%, #0666b1 100%)",
              transform: "translateY(-2px)",
              boxShadow: "0 14px 28px rgba(12, 116, 200, .30)",
            },
          }}
        >
          {text} <span style={{ marginInlineStart: 8 }}>›</span>
        </Button>
      </NavLink>
    );
}
